module.exports = __webpack_public_path__ + "img/biaoti@2x.8f874f42.png";